import { useState } from "react";
import { BooleanField, DateField, MuiDatagrid } from "../../components";
import { GridColDef } from "@mui/x-data-grid";
import { useLocales } from "../../hooks";
import { isExists, params } from "../../utils";
import { useParams } from "react-router-dom";
import { useGetListQuery } from "../../features/api/Api";
import { defaultToolbar } from "../../components/views/datagrid/MuiDatagrid";

const CustomerInvoices = () => {
  const { translate } = useLocales();
  const { customerId } = useParams();
  const [invoiceParams, setInvoiceParams] = useState({
    resource: "fixity/invoice/MerlinInvoice/GetCustomerInvoices/false",
    params: {
      ...params,
      filter: {
        customerId: customerId,
      },
    },
  });

  const { data: invoices, isLoading } = useGetListQuery<any>(invoiceParams);

  const columns: GridColDef[] = [
    {
      field: "faturaNumarasi",
      headerName: "Fatura Numarası",
      flex: 1,
    },
    {
      field: "donem",
      headerName: "Dönem",
      flex: 1,
    },

    {
      field: "hizmet",
      headerName: "Hizmet",
      flex: 1,
    },

    {
      field: "odendiMi",
      headerName: "Ödeme Durumu",
      flex: 1,
      renderCell: ({ row }) => <BooleanField source={row.odendiMi} />,
    },
    {
      field: "tutarVergili",
      headerName: "Vergili Tutar",
      flex: 1,
    },
    {
      field: "paraBirimiKodu",
      headerName: "Para Birimi",
      flex: 1,
    },

    {
      field: "faturaTarihi",
      headerName: "Fatura Tarihi",
      flex: 1,
      renderCell: ({ value }) => <DateField source={value} />,
    },
    {
      field: "sonodemeTarihi",
      headerName: "Son Ödeme Tarihi",
      flex: 1,
      renderCell: ({ value }) => <DateField source={value} />,
    },
  ];
  const pageName = `Faturalar`;
  return (
    <MuiDatagrid
      loading={isLoading}
      rows={isExists(invoices?.data) ? invoices.data : []}
      columns={columns}
      getRowId="idFatura"
      rowCount={invoices?.totalItemCount}
      autoHeight={true}
      pageSize={invoiceParams.params.pagination.size}
      pageNumber={invoiceParams.params.pagination.pageNumber}
      setPagination={setInvoiceParams}
      hideToolbars={{
        ...defaultToolbar,
        create: false,
        filter: false,
        columnVisibility: false,
      }}
    />
  );
};

export default CustomerInvoices;
